import { EdgeProps, getBezierPath, getSmoothStepPath } from 'reactflow';

import styled from 'styled-components';

import { useSidebarState } from '@components/sidebar';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const TravellerEdge = (props: EdgeProps) => {
  const { id, sourceX, sourceY, targetX, targetY, markerEnd } = props;
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 16,
  });

  return <StyledPath id={id} d={edgePath} markerEnd={markerEnd} />;
};

const StyledPath = styled.path.attrs({ className: 'react-flow__edge-path' })({
  strokeWidth: pxToRem(4),
  stroke: `${theme.color.purple20} !important`,
});

export const TravellerSucceedEdge = (props: EdgeProps) => {
  const { id, sourceX, sourceY, targetX, targetY, markerEnd } = props;
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 16,
  });

  return (
    <StyledExtraPath
      id={id}
      d={edgePath}
      markerEnd={markerEnd}
      $color={theme.color.green100}
      $width={4}
    />
  );
};

export const TravellerExtraEdge = (props: EdgeProps) => {
  const { id, sourceX, sourceY, target, targetX, targetY, markerEnd } = props;
  const { activeId } = useSidebarState();
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <StyledExtraPath
      id={id}
      d={edgePath}
      markerEnd={markerEnd}
      $isHidden={activeId !== target}
      $color={theme.color.orange100}
      $width={1}
    />
  );
};

const StyledExtraPath = styled.path.attrs({ className: 'react-flow__edge-path' })<{
  $isHidden?: boolean;
  $color: string;
  $width: number;
}>((p) => ({
  strokeWidth: pxToRem(p.$width),
  stroke: `${p.$color} !important`,
  display: p.$isHidden ? 'none' : 'block',
}));

type LoopEdgeProps = EdgeProps & { isInProgress?: boolean };

export const LoopEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  isInProgress = false,
}: LoopEdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    centerX: targetX,
    borderRadius: 16,
  });
  return <StyledLoopPath id={id} d={edgePath} markerEnd={markerEnd} $isInProgress={isInProgress} />;
};

const StyledLoopPath = styled.path.attrs({ className: 'react-flow__edge-path' })<{
  $isInProgress?: boolean;
}>((p) => ({
  strokeWidth: pxToRem(4),
  strokeDasharray: '8 8',
  stroke: `${p.$isInProgress ? theme.color.orange80 : theme.color.purple20} !important`,
  opacity: p.$isInProgress ? 0.5 : 1,
}));
